const middleware = {}

middleware['authMiddleware'] = require('../middleware/authMiddleware.js')
middleware['authMiddleware'] = middleware['authMiddleware'].default || middleware['authMiddleware']

middleware['clearMessagesMiddleware'] = require('../middleware/clearMessagesMiddleware.js')
middleware['clearMessagesMiddleware'] = middleware['clearMessagesMiddleware'].default || middleware['clearMessagesMiddleware']

middleware['cookieMessageMiddleware'] = require('../middleware/cookieMessageMiddleware.js')
middleware['cookieMessageMiddleware'] = middleware['cookieMessageMiddleware'].default || middleware['cookieMessageMiddleware']

middleware['dropshippingMiddleware'] = require('../middleware/dropshippingMiddleware.js')
middleware['dropshippingMiddleware'] = middleware['dropshippingMiddleware'].default || middleware['dropshippingMiddleware']

middleware['forceV2Middleware'] = require('../middleware/forceV2Middleware.js')
middleware['forceV2Middleware'] = middleware['forceV2Middleware'].default || middleware['forceV2Middleware']

middleware['globalErrorMiddleware'] = require('../middleware/globalErrorMiddleware.js')
middleware['globalErrorMiddleware'] = middleware['globalErrorMiddleware'].default || middleware['globalErrorMiddleware']

middleware['modalMiddleware'] = require('../middleware/modalMiddleware.js')
middleware['modalMiddleware'] = middleware['modalMiddleware'].default || middleware['modalMiddleware']

middleware['modeMiddleware'] = require('../middleware/modeMiddleware.js')
middleware['modeMiddleware'] = middleware['modeMiddleware'].default || middleware['modeMiddleware']

middleware['pageviewMiddleware'] = require('../middleware/pageviewMiddleware.js')
middleware['pageviewMiddleware'] = middleware['pageviewMiddleware'].default || middleware['pageviewMiddleware']

middleware['retailerOnlyMiddleware'] = require('../middleware/retailerOnlyMiddleware.js')
middleware['retailerOnlyMiddleware'] = middleware['retailerOnlyMiddleware'].default || middleware['retailerOnlyMiddleware']

middleware['ticaReferralMiddleware'] = require('../middleware/ticaReferralMiddleware.js')
middleware['ticaReferralMiddleware'] = middleware['ticaReferralMiddleware'].default || middleware['ticaReferralMiddleware']

middleware['versionRefreshMiddleware'] = require('../middleware/versionRefreshMiddleware.js')
middleware['versionRefreshMiddleware'] = middleware['versionRefreshMiddleware'].default || middleware['versionRefreshMiddleware']

middleware['visitMiddleware'] = require('../middleware/visitMiddleware.js')
middleware['visitMiddleware'] = middleware['visitMiddleware'].default || middleware['visitMiddleware']

export default middleware
